import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAddresses } from '../../modules/addresses/types/Adresses';

const emptyAddress: IAddresses = {
  _id: '',
  title: '',
  location: {
    lat: 0,
    lon: 0,
  },
  details: {
    entrance: '',
    intercom: '',
    floor: '',
    apartment: '',
    comment: '',
  },
  label_type: undefined,
  label_value: '',
};

let initialState: IAddresses = emptyAddress;

try {
  const stored = sessionStorage.getItem('editAddress');
  if (stored) initialState = JSON.parse(stored);
} catch {
  sessionStorage.removeItem('editAddress');
}

export const EditAddressesSlice = createSlice({
  name: 'editAddresses',
  initialState,
  reducers: {
    setEditAddress: (_state, action: PayloadAction<IAddresses>) => {
      sessionStorage.setItem('editAddress', JSON.stringify(action.payload));
      return action.payload;
    },
    clearEditAddress: () => {
      sessionStorage.removeItem('editAddress');
      return emptyAddress;
    },
  },
});

export const { setEditAddress, clearEditAddress } = EditAddressesSlice.actions;
export default EditAddressesSlice.reducer;
